webpackJsonp([19843951674672],{

/***/ 62:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createContactLink = exports.combineHeaders = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var combineHeaders = exports.combineHeaders = function combineHeaders() {
	  var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return Object.keys(searchParams).map(function (key) {
	    return key + '=' + encodeURIComponent(searchParams[key]);
	  }).join('&');
	};
	
	var createContactLink = exports.createContactLink = function createContactLink(tel, sms, facetime, email, headers) {
	  var link = void 0;
	  if (email) {
	    link = 'mailto:' + email;
	    if (headers) {
	      link += '?' + combineHeaders(headers);
	    }
	  } else if (tel) {
	    link = 'tel:' + tel;
	  } else if (sms) {
	    link = 'sms:' + sms;
	  } else if (facetime) {
	    link = 'facetime:' + facetime;
	  }
	  return link;
	};
	
	var Obfuscate = function (_Component) {
	  _inherits(Obfuscate, _Component);
	
	  function Obfuscate() {
	    _classCallCheck(this, Obfuscate);
	
	    return _possibleConstructorReturn(this, (Obfuscate.__proto__ || Object.getPrototypeOf(Obfuscate)).apply(this, arguments));
	  }
	
	  _createClass(Obfuscate, [{
	    key: 'render',
	    value: function render() {
	      return this.props.obfuscate ? this.renderObfuscatedLink() : this.renderLink();
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink() {
	      var _props = this.props,
	          tel = _props.tel,
	          sms = _props.sms,
	          facetime = _props.facetime,
	          email = _props.email,
	          obfuscate = _props.obfuscate,
	          headers = _props.headers,
	          children = _props.children,
	          others = _objectWithoutProperties(_props, ['tel', 'sms', 'facetime', 'email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          href: createContactLink(tel, sms, facetime, email, headers)
	        }, others),
	        children || tel || sms || facetime || email
	      );
	    }
	  }, {
	    key: 'reverse',
	    value: function reverse(s) {
	      return s.split('').reverse().join('');
	    }
	  }, {
	    key: 'renderObfuscatedLink',
	    value: function renderObfuscatedLink() {
	      var _props2 = this.props,
	          tel = _props2.tel,
	          sms = _props2.sms,
	          facetime = _props2.facetime,
	          email = _props2.email,
	          obfuscate = _props2.obfuscate,
	          headers = _props2.headers,
	          children = _props2.children,
	          style = _props2.style,
	          href = _props2.href,
	          others = _objectWithoutProperties(_props2, ['tel', 'sms', 'facetime', 'email', 'obfuscate', 'headers', 'children', 'style', 'href']);
	
	      var obsStyle = _extends({}, style || {}, {
	        unicodeBidi: 'bidi-override'
	      });
	
	      if (!children) {
	        obsStyle.direction = 'rtl';
	      }
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          onClick: this.handleClick.bind(this),
	          href: href || 'obfuscated'
	        }, others, {
	          style: obsStyle
	        }),
	        children || this.reverse(tel || sms || facetime || email).replace('(', ')').replace(')', '(')
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      var _props3 = this.props,
	          tel = _props3.tel,
	          sms = _props3.sms,
	          facetime = _props3.facetime,
	          email = _props3.email,
	          headers = _props3.headers;
	
	      window.location.href = createContactLink(tel, sms, facetime, email, headers);
	    }
	  }]);
	
	  return Obfuscate;
	}(_react.Component);
	
	Obfuscate.propTypes = {
	  children: _propTypes.node,
	  tel: _propTypes.string,
	  sms: _propTypes.string,
	  facetime: _propTypes.string,
	  email: _propTypes.string,
	  headers: _propTypes.object,
	  obfuscate: _propTypes.bool,
	  style: _propTypes.object
	};
	
	Obfuscate.defaultProps = {
	  obfuscate: true
	};
	
	exports.default = Obfuscate;

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 1492:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/careerclinic.1426ab80.png";

/***/ }),

/***/ 1493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/carefoodies-grid.f8620811.png";

/***/ }),

/***/ 1494:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/eightwaves.c1a90b7e.png";

/***/ }),

/***/ 1495:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/game.1ca48bfa.png";

/***/ }),

/***/ 1496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ketomau.2f6c073a.png";

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeadlineWithFocus = __webpack_require__(19);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _carefoodiesGrid = __webpack_require__(1493);
	
	var _carefoodiesGrid2 = _interopRequireDefault(_carefoodiesGrid);
	
	var _eightwaves = __webpack_require__(1494);
	
	var _eightwaves2 = _interopRequireDefault(_eightwaves);
	
	var _careerclinic = __webpack_require__(1492);
	
	var _careerclinic2 = _interopRequireDefault(_careerclinic);
	
	var _ketomau = __webpack_require__(1496);
	
	var _ketomau2 = _interopRequireDefault(_ketomau);
	
	var _game = __webpack_require__(1495);
	
	var _game2 = _interopRequireDefault(_game);
	
	var _reactObfuscate = __webpack_require__(27);
	
	var _reactObfuscate2 = _interopRequireDefault(_reactObfuscate);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "c-content-box", style: { paddingTop: "3em" } },
	    _react2.default.createElement(
	      _HeadlineWithFocus2.default,
	      null,
	      _react2.default.createElement(
	        "span",
	        null,
	        " Cool stuff "
	      ),
	      " I have built"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "projects", style: { width: "90vw", marginTop: "1em", display: "flex", flexWrap: "nowrap", overflowX: "scroll", overflowY: "hidden", whiteSpace: "no wrap" } },
	      _react2.default.createElement(
	        "div",
	        { className: "gallery", style: { width: "400px", height: "250px", padding: "0 1em 1em", border: "1px solid white", borderRadius: "6px", margin: "2em 2em 2em 0", flex: "0 0 auto" } },
	        _react2.default.createElement(
	          "div",
	          { className: "gallery-image" },
	          _react2.default.createElement(
	            "a",
	            { href: "https://stark-thicket-79076.herokuapp.com/", target: "_blank" },
	            _react2.default.createElement("img", { className: "img-responsive", src: _carefoodiesGrid2.default, alt: "logo" }),
	            _react2.default.createElement(
	              "div",
	              { className: "gallery-text" },
	              _react2.default.createElement(
	                "h3",
	                { className: "hidden1" },
	                "Node.js & SQL"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "gallery", style: { width: "400px", height: "250px", padding: "0 1em 1em", border: "1px solid white", borderRadius: "6px", margin: "2em", flex: "0 0 auto" } },
	        _react2.default.createElement(
	          "div",
	          { className: "gallery-image" },
	          _react2.default.createElement(
	            "a",
	            { href: "https://eightwaves.herokuapp.com/", target: "_blank" },
	            _react2.default.createElement("img", { className: "img-responsive", src: _eightwaves2.default, alt: "logo" }),
	            _react2.default.createElement(
	              "div",
	              { className: "gallery-text" },
	              _react2.default.createElement(
	                "h3",
	                { className: "hidden1" },
	                "React.js & Rails"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "gallery", style: { width: "400px", height: "250px", padding: "1.5em 1em", border: "1px solid white", borderRadius: "6px", margin: "2em", flex: "0 0 auto" } },
	        _react2.default.createElement(
	          "div",
	          { className: "gallery-image" },
	          _react2.default.createElement(
	            "a",
	            { href: "https://career-clinic.herokuapp.com/", target: "_blank" },
	            _react2.default.createElement("img", { className: "img-responsive", src: _careerclinic2.default, alt: "logo" }),
	            _react2.default.createElement(
	              "div",
	              { className: "gallery-text" },
	              _react2.default.createElement(
	                "h3",
	                { className: "hidden" },
	                "Rails & Postgres"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "gallery", style: { width: "400px", height: "250px", padding: "1.5em 1em", border: "1px solid white", borderRadius: "6px", margin: "2em", flex: "0 0 auto" } },
	        _react2.default.createElement(
	          "div",
	          { className: "gallery-image" },
	          _react2.default.createElement(
	            "a",
	            { href: "http://www.ketomau.com", target: "_blank" },
	            _react2.default.createElement("img", { className: "img-responsive", src: _ketomau2.default, alt: "logo" }),
	            _react2.default.createElement(
	              "div",
	              { className: "gallery-text" },
	              _react2.default.createElement(
	                "h3",
	                { className: "hidden" },
	                "WordPress"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "gallery", style: { width: "400px", height: "250px", padding: "1.5em 1em", border: "1px solid white", borderRadius: "6px", margin: "2em", flex: "0 0 auto" } },
	        _react2.default.createElement(
	          "div",
	          { className: "gallery-image" },
	          _react2.default.createElement(
	            "a",
	            { href: "https://mau-dev.github.io/Project1-What-is-underneath/", target: "_blank" },
	            _react2.default.createElement("img", { className: "img-responsive", src: _game2.default, alt: "logo" }),
	            _react2.default.createElement(
	              "div",
	              { className: "gallery-text" },
	              _react2.default.createElement(
	                "h3",
	                { className: "hidden" },
	                "JavaScript & DOM"
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-jsx-69efedf7b8c46156cd91.js